import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '手机号',
      prop: 'tel'
    },
    {
      label: '身份证号',
      prop: 'code'
    },
    {
      label: '主办方',
      prop: 'orgName'
    },
    {
      label: '级别',
      prop: 'level'
    },
    {
      label: '性别',
      prop: 'gender'
    },
    {
        label: '职业',
        prop: 'position'
    },
    {
        label: '邮箱',
        prop: 'email'
    }
  ]
}
